import { render, staticRenderFns } from "./CardAllowCourier.vue?vue&type=template&id=7bb04c50&"
import script from "./CardAllowCourier.vue?vue&type=script&lang=js&"
export * from "./CardAllowCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports